module.exports = __webpack_public_path__ + "img/founders_1.84cd69c2.jpg";